/* Advertorial interactivity: GemPages FAQ accordions + review/ingredient sliders.
   Re-initialises on Shopify's section-load event so it also works inside the
   theme customizer (which re-renders a section when you open it). */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ── FAQ accordions ──────────────────────────────────────────────────
  // GemPages collapses each answer with an inline `max-height:0` (+ overflow
  // hidden) and opens by animating max-height up. That inline max-height clamps
  // grid-rows/height, so max-height is the only lever that works.
  function innerOf(body) { return body.querySelector('.gp-accordion-item_body-inner') || body; }
  function bodyFor(header) {
    var p = header.parentElement;
    var b = p && p.querySelector('.gp-accordion-item_body');
    if (b) return b;
    var sib = header;
    while ((sib = sib.nextElementSibling))
      if (sib.classList && sib.classList.contains('gp-accordion-item_body')) return sib;
    return null;
  }
  function collapseAccordions(root) {
    (root || document).querySelectorAll('.gp-accordion-item_body').forEach(function (b) {
      b.style.overflow = 'hidden';
      b.style.maxHeight = '0px';
      if (!/max-height/.test(b.style.transition)) b.style.transition = 'max-height .4s ease';
      b.setAttribute('data-adv-open', '0');
    });
    (root || document).querySelectorAll('.gp-accordion-item_header.adv-open')
      .forEach(function (h) { h.classList.remove('adv-open'); });
  }

  // ── Sliders (ingredient carousels + review strips) ──────────────────
  // Make each track (the parent of .gem-slider-item) a horizontal scroll-snap
  // strip. Works for native swipe; arrows call scrollBy on their OWN track.
  // click-and-drag to scroll (desktop mouse), plus native touch swipe
  function enableDrag(track) {
    if (track.dataset.advDrag) return;
    track.dataset.advDrag = '1';
    track.style.cursor = 'grab';
    var down = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.gem-slider-next, .gem-slider-previous, a, button')) return;
      down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
      track.style.cursor = 'grabbing'; track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    function end() {
      if (!down) return;
      down = false;
      track.style.cursor = 'grab'; track.style.scrollBehavior = 'smooth';
      track.style.scrollSnapType = 'x mandatory';
    }
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    // swallow the click that follows a drag so it doesn't trigger links/etc.
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    // don't let images start a native drag ghost
    track.querySelectorAll('img').forEach(function (im) { im.setAttribute('draggable', 'false'); });
  }
  function setupTracks(root) {
    var items = (root || document).querySelectorAll('.gem-slider-item');
    var seen = [];
    items.forEach(function (it) {
      var track = it.parentElement;
      if (seen.indexOf(track) < 0) {
        seen.push(track);
        track.style.setProperty('overflow-x', 'auto', 'important');   // beats gp-overflow-hidden
        track.style.setProperty('overflow-y', 'hidden', 'important');
        track.style.scrollSnapType = 'x mandatory';
        track.style.scrollBehavior = 'smooth';
        track.style.scrollbarWidth = 'none';
        enableDrag(track);
      }
      it.style.scrollSnapAlign = 'start';
      it.style.flex = '0 0 auto';
    });
    // Fit over-wide slides to one track-width. GemPages' `--minw/--maxw:calc(100%)`
    // mis-resolves without their runtime and can blow a slide up to the raw image
    // size, pushing it off-centre. Clamp any slide wider than the track to exactly
    // one view (centred, one-per-view); leave already-fitting sliders alone.
    seen.forEach(function (track) {
      var w = track.clientWidth;
      if (!w) return;
      track.querySelectorAll(':scope > .gem-slider-item').forEach(function (it) {
        if (it.dataset.advFit || it.getBoundingClientRect().width > w + 4) {
          it.dataset.advFit = '1';
          it.style.setProperty('min-width', w + 'px', 'important');
          it.style.setProperty('max-width', w + 'px', 'important');
          it.style.setProperty('width', w + 'px', 'important');
          // The full-width slide row is a 2-col grid (1fr 1fr) with one empty column,
          // so content sits to one side. ONLY for that top-level full-width row,
          // collapse the tracks to content size and centre them (auto tracks + the
          // empty one shrinks to 0, then justify-content centres the content). Leave
          // nested narrower grids (ingredient labels etc.) untouched.
          it.querySelectorAll('[style*="--gtc"]').forEach(function (row) {
            if (row.getBoundingClientRect().width >= w - 4) {
              // single full-width column → the image fills the slide and is centred,
              // and the empty 2nd column drops below (harmless). No overflow.
              row.style.setProperty('grid-template-columns', 'minmax(0,1fr)', 'important');
            }
          });
        }
      });
    });
    // the review strip (custom flex slider) is draggable too
    (root || document).querySelectorAll('.adv-review-slider').forEach(enableDrag);
  }
  // walk up from an arrow to the nearest ancestor that contains slider items,
  // and return that carousel's own track (so each arrow drives its own slider).
  function trackForArrow(btn) {
    var p = btn.parentElement;
    while (p) {
      var item = p.querySelector('.gem-slider-item');
      if (item) return item.parentElement;
      p = p.parentElement;
    }
    return null;
  }

  function initAll(root) {
    collapseAccordions(root);
    setupTracks(root);
  }

  // one-time global click delegation (works for any section, even re-rendered)
  if (!window.__advClicks) {
    window.__advClicks = true;
    document.addEventListener('click', function (e) {
      var h = e.target.closest('.gp-accordion-item_header');
      if (h) {
        var body = bodyFor(h);
        if (!body) return;
        var open = body.getAttribute('data-adv-open') === '1';
        // measure true content height by briefly unclamping (scrollHeight reads 0
        // while clamped on some GemPages bodies)
        var prev = body.style.maxHeight;
        body.style.maxHeight = 'none';
        var target = innerOf(body).scrollHeight + 48;
        body.style.maxHeight = prev || '0px';
        void body.offsetHeight; // reflow so the next change animates
        requestAnimationFrame(function () {
          body.style.maxHeight = open ? '0px' : target + 'px';
        });
        body.setAttribute('data-adv-open', open ? '0' : '1');
        h.classList.toggle('adv-open', !open);
        return;
      }
      var nx = e.target.closest('.gem-slider-next');
      var pv = e.target.closest('.gem-slider-previous');
      if (nx || pv) {
        e.preventDefault();
        var track = trackForArrow(nx || pv);
        if (!track) return;
        var item = track.querySelector('.gem-slider-item');
        var w = item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.85;
        track.scrollBy({ left: (nx ? 1 : -1) * w, behavior: 'smooth' });
      }
    });
    // chevron rotation for open accordions + centre slider images inside their slide
    var st = document.createElement('style');
    st.textContent = '.gp-accordion-item_header.adv-open svg{transform:rotate(180deg);transition:transform .3s}'
      + '.gem-slider-item img{margin-left:auto !important;margin-right:auto !important}';
    document.head.appendChild(st);
  }

  ready(function () { initAll(document); });
  // customizer + dynamic section loads
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
  // re-fit slides on viewport changes (clamped widths are pixel-based)
  var rz; window.addEventListener('resize', function () {
    clearTimeout(rz); rz = setTimeout(function () { setupTracks(document); }, 200);
  });
})();
